import getTimezoneOffset from "date-fns-tz/getTimezoneOffset";
import subMilliseconds from "date-fns/subMilliseconds";

const zonedTimeToLocal = (date: Date, timezone?: string | null) => {
  if (!timezone) {
    return date;
  }

  const offset = getTimezoneOffset(timezone);

  return subMilliseconds(date, offset);
};

export default zonedTimeToLocal;
